import store from '@/store';
import FeaturesService from '@/services/features.service';
/* import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL */

const globals = [
  {
    id: 1,
    name: 'Overall Display Banner settings',
    allowed_types: ['Banner'],
    var_name: 'ad_duration',
    include_in_live: false,
    end_header_code: `
      <scr${'ipt'} src="/uploads/layout_modules/ad-pause.js" type="text/javascript"></scr${'ipt'}>
    `,
    end_body_code: `
      <scr${'ipt'}>
        (function() {
          if (window.AdAnimationController && layoutOptions && layoutOptions.ad_duration && layoutOptions.ad_duration > 0) {
            const adPause = new AdAnimationController();
            adPause.init(document.body, layoutOptions.ad_duration);
          }
        })();
      </scr${'ipt'}>
      `,
    option_types: {
      ad_duration: {
        title: 'Ad Duration',
        tooltip: 'The duration of the ad animations in seconds (0 unlimited)',
        type: 'slider',
        min: 0,
        max: 120,
        default: 30,
        suffix: 'sec'
      }
    }
  },
  {
    id: 2,
    name: 'Polite Load Image Settings',
    allowed_types: ['Banner'],
    var_name: 'polite_settings',
    include_in_live: false,
    end_header_code: `
    `,
    end_body_code: `

      `,
    option_types: {
      polite_duration: {
        title: 'Polite Load Image Duration',
        tooltip: 'The duration of the polite load image in seconds (0 = no showing)',
        type: 'slider',
        min: 0,
        max: 3,
        step: 0.1,
        default: 1,
        suffix: 'sec'
      },
      polite_exit_animation: {
        title: 'Polite Load Image Exit Animation',
        tooltip: 'The exit animation of the polite load image',
        type: 'dropdown',
        values: [
          {
            name: 'None',
            value: 'none'
          },
          {
            name: 'Fade',
            value: 'fade'
          },
          {
            name: 'Slide Up',
            value: 'slide_up'
          },
          {
            name: 'Slide Down',
            value: 'slide_down'
          },
          {
            name: 'Slide Left',
            value: 'slide_left'
          },
          {
            name: 'Slide Right',
            value: 'slide_right'
          },
          {
            name: 'Zoom In',
            value: 'zoom_in'
          },
          {
            name: 'Zoom Out',
            value: 'zoom_out'
          }
        ],
        default: 'fade'
      },
      polite_exit_animation_duration: {
        title: 'Polite Load Image Exit Animation Duration',
        tooltip: 'The duration of the polite load image exit animation in milliseconds (0 = immediate)',
        type: 'slider',
        min: 0,
        max: 1000,
        step: 50,
        default: 300,
        suffix: 'ms'
      }
    }
  }
];

const layouts = [
  {
    id: 'mrqYSj3J',
    name: 'In-Banner Video',
    allowed_types: ['Banner'],
    module_name: 'videoplayer',
    required_assets: ['videoplayer.js'],
    assets: [
      {
        id: 1,
        name: 'Banner Video',
        type: 'video/mp4',
        required: true,
        filename: 'main.mp4'
      }
    ],
    allowHTML: true,
    end_header_code: `
      <link rel="stylesheet" href="/uploads/layout_modules/videoplayer/videoplayer.css">
    `,
    pre_body_code: `
      <div id="video_container" style="position: absolute;width: 100%;height: 100%;z-index:-1;top:0;left:0;"></div>
    `,
    end_body_code: `
      <div id="video_controls" style="position: absolute;z-index:1;top:0;left:0;"></div>
      <scr${'ipt'} src="/uploads/layout_modules/videoplayer/videoplayer.js"></scr${'ipt'}>
      <scr${'ipt'}>
        (function() {
            const playerArrangement = layoutOptions.video_player_arrangement || 'foreground';
            const videoContainer = playerArrangement === 'background' ? 'video_container' : 'video_controls';
            const videoControls = playerArrangement === 'background' ? 'video_controls' : 'video_container';
            const videoContainerEl = document.getElementById(videoContainer);
            const videoControlsEl = document.getElementById(videoControls);
            let vidWidth = "300px";
            let vidHeight = "250px";
            if (layoutOptions.assets) {
              layoutOptions.assets.forEach((asset) => {
                if (asset.filename === 'main.mp4' && asset.width && asset.height) {
                  const ratio = asset.height / asset.width;
                  vidWidth = layoutOptions.width + 'px';
                  vidHeight = Math.ceil(layoutOptions.width * ratio) + 'px';
                }
              })
            }
            if (layoutOptions.video_player_Y_position) {
              const yPosition = layoutOptions.video_player_Y_position + '%';
              videoContainerEl.style.top = yPosition;
              videoControlsEl.style.top = yPosition;
            }
            if (layoutOptions.video_player_X_position) {
              const xPosition = layoutOptions.video_player_X_position + '%';
              videoContainerEl.style.left = xPosition;
              videoControlsEl.style.left = xPosition;
            }

            if (layoutOptions.video_player_size) {
              const size = Number(layoutOptions.video_player_size) / 100;
              vidWidth = Math.ceil(parseInt(vidWidth) * size) + 'px';
              vidHeight = Math.ceil(parseInt(vidHeight) * size) + 'px';
            }

            const player = new VideoPlayer(videoContainer, Object.assign({}, {
                video_url : "./main.mp4?tld=" + Date.now(),
                video_autoplay    : "yes",
                video_width       : vidWidth,
                video_height      : vidHeight,
                buttons_position  : "bottom over",
                button_left_size  : "100%",
                button_right_size : "100%",
                controls_container : playerArrangement === 'background' ? 'video_controls' : null,
                big_playBtn_img_url            : layoutOptions.big_playBtn_img_url || '/uploads/layout_modules/videoplayer/images/play.svg',
                big_replayBtn_img_url          : layoutOptions.big_replayBtn_img_url || '/uploads/layout_modules/videoplayer/images/replay.svg',
                small_playBtn_img_url          : layoutOptions.small_playBtn_img_url || '/uploads/layout_modules/videoplayer/images/play.svg',
                small_pauseBtn_img_url         : layoutOptions.small_pauseBtn_img_url || '/uploads/layout_modules/videoplayer/images/pause.svg',
                small_replayBtn_img_url        : layoutOptions.small_replayBtn_img_url || '/uploads/layout_modules/videoplayer/images/replay.svg',
                mute_url                       : layoutOptions.mute_url || '/uploads/layout_modules/videoplayer/images/mute.svg',
                unmute_url                     : layoutOptions.unmute_url || '/uploads/layout_modules/videoplayer/images/unmute.svg'
            }, layoutOptions));
          

        })();
      </scr${'ipt'}>
    `,
    option_types: {
      video_autoplay: {
        title: 'Video Autoplay',
        tooltip: 'Whether the video should autoplay',
        type: 'toggle',
        values: [
          {
            name: 'Yes',
            value: 'yes'
          },
          {
            name: 'No',
            value: 'no'
          }
        ],
        default: 'yes'
      },
      progress_type: {
        title: 'Progress Type',
        tooltip: 'Which way to show the progress of the video',
        type: 'dropdown',
        values: [
          {
            name: 'Progress Bar',
            value: 'ProgressBar'
          },
          {
            name: 'Countdown',
            value: 'Countdown'
          }
        ],
        default: 'Countdown'
      },
      loop: {
        title: 'Loop',
        tooltip: 'Whether the video should loop',
        type: 'toggle',
        values: [
          {
            name: 'Yes',
            value: 'yes'
          },
          {
            name: 'No',
            value: 'no'
          }
        ],
        default: 'no'
      },
      controls: {
        title: 'Controls',
        tooltip: 'Whether the video should show controls',
        type: 'toggle',
        values: [
          {
            name: 'Yes',
            value: 'yes'
          },
          {
            name: 'No',
            value: 'no'
          }
        ],
        default: 'yes'
      },
      show_countdown: {
        title: 'Show Countdown',
        tooltip: 'Whether the video play button show countdown to end of the video',
        type: 'toggle',
        values: [
          {
            name: 'Yes',
            value: 'yes'
          },
          {
            name: 'No',
            value: 'no'
          }
        ],
        default: 'yes'
      },
      buttons_position: {
        title: 'Buttons Placement',
        tooltip: 'The placement of the controls layout',
        type: 'dropdown',
        values: [
          {
            name: 'Grouped Top Left',
            value: 'top left'
          },
          {
            name: 'Inside Top Right',
            value: 'top right'
          },
          {
            name: 'Inside Bottom Left',
            value: 'bottom left'
          },
          {
            name: 'Inside Bottom Right',
            value: 'bottom right'
          },
          {
            name: 'Separated Bottom Over',
            value: 'bottom over'
          },
          {
            name: 'Separated Bottom Under',
            value: 'bottom under'
          },
          {
            name: 'Separated Top Over',
            value: 'top over'
          }
        ],
        default: 'bottom over'
      },
      buttons_sizes: {
        title: 'Buttons Sizes',
        tooltip: 'The size of the buttons',
        type: 'slider',
        min: 0,
        max: 500,
        default: 100,
        suffix: '%'
      },
      video_player_delay: {
        title: 'Video Player Delay',
        tooltip: 'The delay of the video player',
        type: 'slider',
        min: 0,
        max: 15,
        default: 0,
        suffix: 's'
      },
      video_player_X_position: {
        title: 'Video Player X Position',
        tooltip: 'The X position of the video player',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      video_player_Y_position: {
        title: 'Video Player Y Position',
        tooltip: 'The Y position of the video player',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      video_player_size: {
        title: 'Video Player Size (% of the ad size)',
        tooltip: 'The size of the video player',
        type: 'slider',
        min: 0,
        max: 300,
        default: 100,
        suffix: '%'
      },
      video_border_radius: {
        title: 'Video Player Corner Radius',
        tooltip: 'The corner radius of the video player',
        type: 'slider',
        min: 0,
        max: 300,
        default: 0,
        suffix: 'px'
      },
      video_player_arrangement: {
        title: 'Video Player Arrangement',
        tooltip: 'The arrangement of the video player',
        type: 'dropdown',
        values: [
          {
            name: 'Background',
            value: 'background'
          },
          {
            name: 'Foreground',
            value: 'foreground'
          }
        ],
        default: 'foreground'
      },
      button_left_X_position: {
        title: 'Play/Pause X Position',
        tooltip: 'The X position of the Play/Pause button',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      button_left_Y_position: {
        title: 'Play/Pause Y Position',
        tooltip: 'The Y position of the Play/Pause button',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      button_right_X_position: {
        title: 'Mute/Unmute X Position',
        tooltip: 'The X position of the Mute/Unmute button',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      button_right_Y_position: {
        title: 'Mute/Unmute Y Position',
        tooltip: 'The Y position of the Mute/Unmute button',
        type: 'slider',
        min: -100,
        max: 100,
        default: 0,
        suffix: '%'
      },
      big_playBtn_img_url: {
        title: 'Big Play Button Image URL',
        tooltip: 'The image URL of the big play button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/play.svg',
        hidden: true
      },
      big_replayBtn_img_url: {
        title: 'Big Replay Button Image URL',
        tooltip: 'The image URL of the big replay button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/replay.svg',
        hidden: true
      },
      small_playBtn_img_url: {
        title: 'Small Play Button Image URL',
        tooltip: 'The image URL of the small play button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/play.svg',
        hidden: true
      },
      small_pauseBtn_img_url: {
        title: 'Small Pause Button Image URL',
        tooltip: 'The image URL of the small pause button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/pause.svg',
        hidden: true
      },
      small_replayBtn_img_url: {
        title: 'Small Replay Button Image URL',
        tooltip: 'The image URL of the small replay button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/replay.svg',
        hidden: true
      },
      mute_url: {
        title: 'Mute Button Image URL',
        tooltip: 'The image URL of the mute button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/mute.svg',
        hidden: true
      },
      unmute_url: {
        title: 'Unmute Button Image URL',
        tooltip: 'The image URL of the unmute button',
        type: 'asset',
        default: '/uploads/layout_modules/videoplayer/images/unmute.svg',
        hidden: true
      }
    },
    options: {
      video_autoplay: true,
      progress_bar: false,
      loop: true,
      controls: false,
      show_countdown: true,
      buttons_position  : "bottom over"
    }
  }
];
class LayoutsService {
  getAll() {
    return layouts;
  }
  getAllLayoutOptions() {
    return layouts;
  }
  getGlobals() {
    return globals;
  }
  adjustHTMLForLayout(htmlInput, creative, isPreview = true) {
    let output = htmlInput;
    
    if (creative && creative.layout) {
        const layout = layouts.find(layout => layout.id === creative.layout || layout.name === creative.layout);
        if (layout) {
          const layoutOptions = store.getters['campaigns/getCreativeSetting'](creative, 'creativeSettings') || {};
          const layoutAssets = creative.assets.filter((asset) => layout.assets.find((a) => a.filename === asset.filename));
          const requiredAssets = layout.assets.filter((asset) => asset.required);
          const assetsExists = requiredAssets.filter((asset) => creative.assets.find((a) => a.filename === asset.filename));
          const featuresVal = store.getters['campaigns/getCreativeSetting'](creative, 'features');
          const featureAssets = FeaturesService.getFeatureAssetsForCreative(featuresVal, creative.assets || []);
          const injectedAssets = [...layoutAssets];
          featureAssets.forEach((asset) => {
            if (!injectedAssets.find((a) => a.id === asset.id || a.filename === asset.filename)) {
              injectedAssets.push(asset);
            }
          });
          let assetsGood = false;
          console.log("Layout options",layoutOptions);
          const injectedOptions = Object.assign({}, layoutOptions, {
              width: creative.width,
              height: creative.height,
              assets: injectedAssets
          });


          let endBodyCode = '';
          let endHeaderCode = '';
          let preBodyCode = '';
          globals.forEach((global) => {
            const isUsable = isPreview ? true : global.include_in_live == true;
            if (isUsable && injectedOptions[global.var_name]) {
              endBodyCode = (global.end_body_code) ? global.end_body_code + endBodyCode : endBodyCode;
              endHeaderCode = (global.end_header_code) ? global.end_header_code + endHeaderCode : endHeaderCode;
              preBodyCode = (global.pre_body_code) ? global.pre_body_code + preBodyCode : preBodyCode;
            }
          });

          if (assetsExists.length === requiredAssets.length) {
              assetsGood = true;
          }
          const htmlForInjectedOptions = '<scr'+'ipt'+' id="ad-options">const layoutOptions = '+JSON.stringify(injectedOptions)+';</scr'+'ipt>';

          if (assetsGood) {
            endBodyCode += layout.end_body_code || '';
            endHeaderCode += layout.end_header_code || '';
            preBodyCode += layout.pre_body_code || '';  
          }

          endHeaderCode = htmlForInjectedOptions + endHeaderCode;
          
          if (output.indexOf('</head>') < 0) {
            preBodyCode = endHeaderCode + preBodyCode;
          }

          if (output.indexOf('<body') < 0) {
            endBodyCode = preBodyCode + endBodyCode;
          }
          
          output = output.replace('</head>', endHeaderCode + '</head>');
          output = output.replace(/<body([^>]*)>/gi, '<body$1>' + preBodyCode);

          if (output.indexOf('</body>') < 0) {
            output = output + endBodyCode;
          } else {
            output = output.replace('</body>', endBodyCode + '</body>');
          }
          
        }
    }
    if (isPreview === false) {
      output = output.replace(/\/uploads\/layout_modules\//g, '');
    }
    output = output.replace(/\\x3C/g, '<');
    return output;
  }
}

export default new LayoutsService();
